import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { EmissionsRoadMaintenanceActivities } from '../../../../../../../services/types/CalculatorTransportRoads';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  emissionsRoadMaintenanceActivities: EmissionsRoadMaintenanceActivities;
}

const EmissionsRoadMaintenanceActivitiesDetails: React.FC<Props> = ({
  emissionsRoadMaintenanceActivities,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper">
      <Table
        responsive
        className="table--bordered calculator table-details"
        style={{ tableLayout: 'fixed' }}
      >
        <colgroup>
          <col style={{ width: '50%' }} />
          <col style={{ width: '50%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('Default Emission Factor')}</th>
            <th>{parse(t('CO<sub>2</sub> Emissions (t CO<sub>2</sub>)'))}</th>
          </tr>
        </thead>
        <tbody>
          {emissionsRoadMaintenanceActivities.subTotal &&
            emissionsRoadMaintenanceActivities.factorValue && (
              <tr>
                <td>
                  <NumberFormatterSinSeparador
                    value={emissionsRoadMaintenanceActivities.factorValue}
                  />
                </td>
                <td>
                  <NumberFormatterSinSeparador
                    value={emissionsRoadMaintenanceActivities.subTotal}
                  />
                </td>
              </tr>
            )}
        </tbody>
        <tfoot>
          <tr>
            {/* espaciador intencional, sin contenido */}
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <td colSpan={2} />
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default EmissionsRoadMaintenanceActivitiesDetails;
